import { ChangeDetectorRef, Directive, OnInit } from '@angular/core';
import { IHotelAvailability } from '@core/models/HotelAvailability/IHotelAvailability';
import { ReqService, SearchStateService } from '@core/services';
import { BehaviorSubject, Subject } from 'rxjs';
import { DISNEY_DINING_CARD_CODES, DISNEY_FREE_MEAL_PLAN_CODES } from '../../../../shared/constants/disney-offer-codes';
import { Room } from '@core/models/Room/Room.model';
import { Rate } from '@core/models/Rate/Rate.model';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export class RoomOptions implements OnInit {
  public openRefundableRateAlert: boolean;
  public openPaymentsMethodsAlert: any;
  public prepaidRooms: Array<any>;
  public payAtDestinationRooms: any;
  public filteredRefundablePrepaidRooms: Array<any>;
  public filteredRefundablePayAtDestinationRooms: Array<any>;
  public allRooms: any;
  public paidRooms: any;
  public displayAllRooms: boolean;
  public showAllBtn: boolean;
  public roomsLength: number;
  public showPaymentMethodSelector: boolean;
  public showRefundableRateSwitch: boolean;
  public refundableRate: boolean;
  public brandImage: string;
  public brandImages: Array<string> = ['avantrip'];
  public mealPlanFilter: Array<any> = [];
  public mealPlan: any = 'ALL';
  public allPaidRooms: any[];
  public isExperts: boolean;
  public hasTicketsInClusters = false;
  public hasMealPlanFilters = false;
  public disneyPaidRooms = [];
  public hotelAvailabilityInfo: IHotelAvailability;
  public isDisney: boolean;
  public paymentMethodValue: any;
  protected disneyCluster$: Subject<any[]> = new BehaviorSubject(null);
  protected searchStateService: SearchStateService;
  protected cdr: ChangeDetectorRef;
  protected reqService: ReqService;

  constructor(
    searchStateService: SearchStateService,
    reqService: ReqService,
    cdr: ChangeDetectorRef,
  ) {
    this.searchStateService = searchStateService;
    this.cdr = cdr;
    this.reqService = reqService;
  }

  ngOnInit() {
    if (this.brandImages.includes(this.reqService.getBrand())) {
      this.brandImage = `${this.reqService.getBrand()}-image`;
    } else {
      this.brandImage = 'almundo-image';
    }

    this.prepaidRooms = this.hotelAvailabilityInfo.prepaid_room_clusters;
    this.payAtDestinationRooms =
      this.hotelAvailabilityInfo.paid_at_destination_room_clusters;
    this.allRooms = this.prepaidRooms.concat(this.payAtDestinationRooms);
    if (this.allRooms.length > 0) {
      this.paidRooms = [];
      this.displayAllRooms = false;
      this.roomsLength = 2;
      this.showPaymentMethodSelector =
        !this.isDisney && this.prepaidRooms.length && this.payAtDestinationRooms.length;
      this.showRefundableRateSwitch =
        !this.isDisney && this.checkRefundableRateVisibility();
      this.filteredRefundablePrepaidRooms =
        this.hotelAvailabilityInfo.refundable_prepaid_room_clusters;
      this.filteredRefundablePayAtDestinationRooms =
        this.hotelAvailabilityInfo.refundable_paid_at_destination_room_clusters;
      this.refundableRate = this.searchStateService.getFlexible();
      this.isExperts = this.reqService.isExperts();
      this.showRooms(true);
    }
  }

  /**
   * Show the differents rooms
   */
  public showRooms(noSum = false) {
    this.roomsLength += noSum ? 0 : 2;
    switch (this.paymentMethodValue) {
      case 'PREPAID':
        if (this.refundableRate) {
          this.paidRooms = this.filteredRefundablePrepaidRooms.slice(0, this.roomsLength);
          this.showAllBtn =
            this.filteredRefundablePrepaidRooms.length > this.paidRooms.length;
        } else {
          this.paidRooms = this.prepaidRooms.slice(0, this.roomsLength);
          this.showAllBtn = this.prepaidRooms.length > this.paidRooms.length;
        }
        break;
      case 'PAY_AT_DESTINATION':
        if (this.refundableRate) {
          this.paidRooms = this.filteredRefundablePayAtDestinationRooms.slice(
            0,
            this.roomsLength,
          );
          this.showAllBtn =
            this.filteredRefundablePayAtDestinationRooms.length > this.paidRooms.length;
        } else {
          this.paidRooms = this.payAtDestinationRooms.slice(0, this.roomsLength);
          this.showAllBtn = this.payAtDestinationRooms.length > this.paidRooms.length;
        }
        break;
      default:
        if (this.prepaidRooms.length && this.payAtDestinationRooms.length) {
          if (this.refundableRate) {
            this.paidRooms = [
              ...this.filteredRefundablePrepaidRooms.slice(0, this.roomsLength / 2),
              ...this.filteredRefundablePayAtDestinationRooms.slice(
                0,
                this.roomsLength / 2,
              ),
            ];
          } else {
            this.paidRooms = [
              ...this.prepaidRooms.slice(0, this.roomsLength / 2),
              ...this.payAtDestinationRooms.slice(0, this.roomsLength / 2),
            ];
          }
        } else {
          if (this.refundableRate) {
            this.paidRooms = this.filteredRefundablePrepaidRooms.length
              ? this.filteredRefundablePrepaidRooms.slice(0, this.roomsLength)
              : this.filteredRefundablePayAtDestinationRooms.slice(0, this.roomsLength);
          } else {
            this.paidRooms = this.prepaidRooms.length
              ? this.prepaidRooms.slice(0, this.roomsLength)
              : this.payAtDestinationRooms.slice(0, this.roomsLength);
          }
        }
        if (!this.isDisney) {
          if (this.refundableRate) {
            this.showAllBtn =
              this.filteredRefundablePrepaidRooms.length +
              this.filteredRefundablePayAtDestinationRooms.length >
              this.paidRooms.length;
          } else {
            this.showAllBtn =
              this.prepaidRooms.length + this.payAtDestinationRooms.length >
              this.paidRooms.length;
          }
        } else {
          this.paidRooms = this.prepaidRooms;
        }
        break;
    }
    this.allPaidRooms = this.paidRooms;
    this.createDisneyRooms();
  }

  /**
   * Checks refundable rate component visibility
   */
  private checkRefundableRateVisibility() {
    let refundable = false;
    let nonrefundable = false;
    this.allRooms.forEach((room) => {
      if (room.rates.some((rate) => rate.refundable)) {
        refundable = true;
      }
      if (room.rates.some((rate) => !rate.refundable)) {
        nonrefundable = true;
      }
    });
    return refundable && nonrefundable;
  }

  filterByExperts(paidRooms: any[]) {
    let temporallyPaidRooms = [];
    if (!this.isExperts) {
      temporallyPaidRooms = paidRooms.filter((paidRoom) => {
        if (
          this.splitNameMealPLan(paidRoom.rooms[0].room_description.description) !==
          undefined
        ) {
          return false;
        }
        return true;
      });
    } else {
      temporallyPaidRooms = [...paidRooms];
    }

    return temporallyPaidRooms;
  }

  createDisneyRooms() {
    if (this.isDisney) {
      this.groupRooms(this.paidRooms);
      this.hasTicketsInClusters = this.hasClusterWithTicket();
      this.hasMealPlanFilters = this.hasMealPlanFilter();
    }
  }

  splitNameMealPLan(nameRoom: string): string {
    const nameMealPlan = nameRoom.split(':')[1];
    return nameMealPlan;
  }

  groupRooms(listRoom: []) {
    const namesRooms: Set<string> = new Set<string>();
    this.disneyPaidRooms = [];
    listRoom.forEach((paidRoom: any) => {
      const parsedName = this.splitRoomName(
        paidRoom.rooms[0].room_description.description,
      );
      const room: Room = paidRoom.rooms[0];
      room.offerCode = parsedName.code ? parsedName.code.replace('-', '') : null;
      room.parsedName = parsedName.name;
      room.mealPlanName = parsedName.mealPlan;
      namesRooms.add(parsedName.name);
    });

    if (namesRooms.size > 0) {
      const specialOffer: any[] = [];
      namesRooms.forEach(nameRoom => {
        const optionsRoom: any[] = listRoom.filter((room: any) => {
          const nameActualRoom = this.splitRoomName(
            room.rooms[0].room_description.description,
          );

          /** Si tiene un codigo de oferta para planes de comida gratuito, la habitacion no se agrupa con las demas */
          if (
            nameActualRoom.code &&
            (DISNEY_DINING_CARD_CODES.includes(nameActualRoom.code.replace('-', '')) ||
              DISNEY_FREE_MEAL_PLAN_CODES.includes(nameActualRoom.code.replace('-', '')))
          ) {
            (room.rooms[0] as any).hasDiningCard = true;
            specialOffer.push(room);
            return false;
          }
          return nameActualRoom.name === nameRoom;
        });
        if (specialOffer.length > 0) {
          this.disneyPaidRooms.push(this.createOptionsRoom(specialOffer));
        }
        this.disneyPaidRooms.push(this.createOptionsRoom(optionsRoom));
      });
    }
    this.disneyCluster$.next(this.disneyPaidRooms);
  }

  hasClusterWithTicket(): boolean {
    const roomsWithTicket = this.allPaidRooms.filter((paidRoom) => {
      return paidRoom.disney_meal_plans[0].rates.length > 1;
    });
    return roomsWithTicket.length > 0;
  }

  hasMealPlanFilter(): boolean {
    if (this.mealPlanFilter.length > 0) {
      return (
        this.mealPlanFilter.find((mealPlan) => {
          return mealPlan.code !== 'ROOM_ONLY';
        }) !== undefined
      );
    } else {
      return false;
    }
  }

  public splitRoomName(nameRoom: string): {
    name: string;
    code: string;
    mealPlan: string;
  } {
    const offerCodeRegex = /-\d+[A-Z0-9]*C/g;
    const nameSplitted: string[] = nameRoom.split(':');
    let roomNameParsed = nameSplitted[0].trim();
    const codeRegexMatch = roomNameParsed.match(offerCodeRegex);
    const code = codeRegexMatch ? codeRegexMatch.shift() : null;

    if (code) {
      roomNameParsed = roomNameParsed.replace(code, '');
    }

    if (roomNameParsed.charAt(roomNameParsed.length - 1) !== '.') {
      roomNameParsed = roomNameParsed + '.';
    }
    return {
      name: roomNameParsed,
      mealPlan: nameSplitted[1] ? nameSplitted[1].trim() : null,
      code,
    };
  }

  createOptionsRoom(optionsRooms: any) {
    const roomOptions = {
      disney_meal_plans: [],
      rooms: null,
      offerCodes: [],
      rates: [],
      prioritized_by_rate_filter: false,
    };

    let offerCodes = [];

    optionsRooms.forEach((optionRoom) => {
      const room: Room = optionRoom.rooms[0];
      
      if (optionRoom.prioritized_by_rate_filter) {
        roomOptions.prioritized_by_rate_filter = true;
      }

      offerCodes.push(room.offerCode);

      if (roomOptions.rooms === null) {
        roomOptions.rooms = optionRoom.rooms;
      }

      let rates: Rate[];

      if (room.mealPlanName) {
        const nameMealPLan = room.mealPlanName.replace('"', '').replace(' ', ' ');

        rates = optionRoom.disney_meal_plans[0].rates;
        rates.forEach((rate) => {
          (rate.meal_plan as any).description = nameMealPLan;
        });
      } else {
        rates = optionRoom.disney_meal_plans[0].rates;
      }

      if ((roomOptions as any).rates) {
        roomOptions.rates = (roomOptions as any).rates.concat(rates);
      } else {
        roomOptions.rates = rates;
      }
    });
    offerCodes = offerCodes.filter((code) => code !== null);
    if (offerCodes.length > 0) {
      roomOptions.offerCodes = offerCodes;
    }
    return roomOptions;
  }

  private setFilterMealPlan() {
    if (this.isExperts) {
      let arrayMealPlan = [];
      this.allRooms.forEach((room) => {
        const roomName = room.rooms[0].room_description.description;
        if (this.isDisney) {
          room.disney_meal_plans[0].rates.forEach((rate) => {
            const mealPlan = arrayMealPlan.filter((mealPlanData) => {
              const mealPlanName = this.splitNameMealPLan(roomName);
              if (mealPlanName !== undefined) {
                return mealPlanData.code === mealPlanName;
              }
              return mealPlanData.code === rate.meal_plan.code;
            });
            if (mealPlan.length === 0) {
              const mealPlanByRate = rate.meal_plan;
              if (rate.meal_plan.code !== 'ROOM_ONLY') {
                mealPlanByRate.description = this.splitNameMealPLan(roomName);
                mealPlanByRate.code = this.splitNameMealPLan(roomName);
              }
              arrayMealPlan = [...arrayMealPlan, rate.meal_plan];
            }
          });
        } else {
          room.rates.forEach((rate) => {
            const mealplan = arrayMealPlan.filter(
              (mealPlan) => mealPlan.code === rate.meal_plan.code,
            );
            if (mealplan.length === 0) {
              arrayMealPlan = [...arrayMealPlan, rate.meal_plan];
            }
          });
        }
      });
      this.mealPlanFilter = arrayMealPlan;
    }
  }
}
